// Mock data generator for athlete search results

// Helper function to generate random number within range
const randomNumber = (min, max, decimals = 0) => {
  const rand = Math.random() * (max - min) + min;
  const power = Math.pow(10, decimals);
  return Math.floor(rand * power) / power;
};

// Helper function to generate random element from array
const randomElement = (array) => {
  return array[Math.floor(Math.random() * array.length)];
};

// Helper function to generate random boolean with probability
const randomBoolean = (probability = 0.5) => {
  return Math.random() < probability;
};

// Helper function to generate random date within range
const randomDate = (start, end) => {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  );
};

// Constants for mock data generation
const FIRST_NAMES = [
  "James",
  "John",
  "Robert",
  "Michael",
  "William",
  "David",
  "Richard",
  "Joseph",
  "Thomas",
  "Charles",
  "Christopher",
  "Daniel",
  "Matthew",
  "Anthony",
  "Mark",
  "Donald",
  "Steven",
  "Paul",
  "Andrew",
  "Joshua",
  "Kenneth",
  "Kevin",
  "Brian",
  "George",
  "Timothy",
  "Ronald",
  "Jason",
  "Edward",
  "Jeffrey",
  "Ryan",
  "Jacob",
  "Gary",
  "Nicholas",
  "Eric",
  "Jonathan",
  "Stephen",
  "Larry",
  "Justin",
  "Scott",
  "Brandon",
  "Benjamin",
  "Samuel",
  "Gregory",
  "Alexander",
  "Patrick",
  "Frank",
  "Raymond",
  "Jack",
  "Dennis",
  "Jerry",
  "Tyler",
  "Aaron",
  "Jose",
  "Adam",
  "Nathan",
  "Henry",
  "Zachary",
  "Douglas",
  "Peter",
  "Kyle",
  "Noah",
  "Ethan",
  "Jeremy",
  "Walter",
  "Christian",
  "Keith",
  "Roger",
  "Terry",
  "Austin",
  "Sean",
  "Gerald",
  "Carl",
  "Harold",
  "Dylan",
  "Arthur",
  "Lawrence",
  "Jordan",
  "Jesse",
  "Bryan",
  "Billy",
  "Joe",
  "Bruce",
  "Gabriel",
  "Logan",
  "Albert",
  "Willie",
  "Alan",
  "Juan",
  "Wayne",
  "Elijah",
  "Randy",
  "Roy",
  "Vincent",
  "Ralph",
  "Eugene",
  "Russell",
  "Bobby",
  "Mason",
  "Philip",
  "Louis",
];

const LAST_NAMES = [
  "Smith",
  "Johnson",
  "Williams",
  "Jones",
  "Brown",
  "Davis",
  "Miller",
  "Wilson",
  "Moore",
  "Taylor",
  "Anderson",
  "Thomas",
  "Jackson",
  "White",
  "Harris",
  "Martin",
  "Thompson",
  "Garcia",
  "Martinez",
  "Robinson",
  "Clark",
  "Rodriguez",
  "Lewis",
  "Lee",
  "Walker",
  "Hall",
  "Allen",
  "Young",
  "Hernandez",
  "King",
  "Wright",
  "Lopez",
  "Hill",
  "Scott",
  "Green",
  "Adams",
  "Baker",
  "Gonzalez",
  "Nelson",
  "Carter",
  "Mitchell",
  "Perez",
  "Roberts",
  "Turner",
  "Phillips",
  "Campbell",
  "Parker",
  "Evans",
  "Edwards",
  "Collins",
  "Stewart",
  "Sanchez",
  "Morris",
  "Rogers",
  "Reed",
  "Cook",
  "Morgan",
  "Bell",
  "Murphy",
  "Bailey",
  "Rivera",
  "Cooper",
  "Richardson",
  "Cox",
  "Howard",
  "Ward",
  "Torres",
  "Peterson",
  "Gray",
  "Ramirez",
  "James",
  "Watson",
  "Brooks",
  "Kelly",
  "Sanders",
  "Price",
  "Bennett",
  "Wood",
  "Barnes",
  "Ross",
  "Henderson",
  "Coleman",
  "Jenkins",
  "Perry",
  "Powell",
  "Long",
  "Patterson",
  "Hughes",
  "Flores",
  "Washington",
  "Butler",
  "Simmons",
  "Foster",
  "Gonzales",
  "Bryant",
  "Alexander",
  "Russell",
  "Griffin",
  "Diaz",
  "Hayes",
];

const HIGH_SCHOOLS = [
  "Lincoln High School",
  "Washington High School",
  "Jefferson High School",
  "Roosevelt High School",
  "Madison High School",
  "Franklin High School",
  "Hamilton High School",
  "Central High School",
  "Westview High School",
  "Eastside High School",
  "Northside High School",
  "Southside High School",
  "Riverside High School",
  "Lakeside High School",
  "Hillside High School",
  "Oak Ridge High School",
  "Pine Valley High School",
  "Maple Grove High School",
  "Cedar Ridge High School",
  "Willow Creek High School",
  "Summit High School",
  "Valley View High School",
  "Highland High School",
  "Meadow Brook High School",
  "Fairview High School",
  "Clearwater High School",
  "Greenfield High School",
  "Brookside High School",
  "Sunset High School",
  "Sunrise High School",
];

const STATES = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

const CITIES = {
  CA: [
    "Los Angeles",
    "San Francisco",
    "San Diego",
    "Sacramento",
    "Fresno",
    "Oakland",
    "San Jose",
  ],
  TX: [
    "Houston",
    "Dallas",
    "Austin",
    "San Antonio",
    "Fort Worth",
    "El Paso",
    "Arlington",
  ],
  FL: [
    "Miami",
    "Orlando",
    "Tampa",
    "Jacksonville",
    "Tallahassee",
    "Fort Lauderdale",
    "Gainesville",
  ],
  NY: [
    "New York City",
    "Buffalo",
    "Rochester",
    "Syracuse",
    "Albany",
    "Yonkers",
    "Utica",
  ],
  OH: [
    "Cleveland",
    "Cincinnati",
    "Columbus",
    "Toledo",
    "Akron",
    "Dayton",
    "Canton",
  ],
  GA: [
    "Atlanta",
    "Savannah",
    "Augusta",
    "Columbus",
    "Macon",
    "Athens",
    "Albany",
  ],
  PA: [
    "Philadelphia",
    "Pittsburgh",
    "Allentown",
    "Erie",
    "Reading",
    "Scranton",
    "Bethlehem",
  ],
  IL: [
    "Chicago",
    "Aurora",
    "Rockford",
    "Joliet",
    "Naperville",
    "Springfield",
    "Peoria",
  ],
  MI: [
    "Detroit",
    "Grand Rapids",
    "Warren",
    "Sterling Heights",
    "Lansing",
    "Ann Arbor",
    "Flint",
  ],
  NC: [
    "Charlotte",
    "Raleigh",
    "Greensboro",
    "Durham",
    "Winston-Salem",
    "Fayetteville",
    "Cary",
  ],
};

const FOOTBALL_POSITIONS = [
  "QB",
  "RB",
  "FB",
  "WR",
  "TE",
  "OT",
  "OG",
  "C",
  "DE",
  "DT",
  "LB",
  "CB",
  "S",
  "K",
  "P",
];
const BASKETBALL_POSITIONS = ["PG", "SG", "SF", "PF", "C"];
const BASEBALL_POSITIONS = [
  "P",
  "C",
  "1B",
  "2B",
  "3B",
  "SS",
  "LF",
  "CF",
  "RF",
  "DH",
];

const SPORTS = [
  { name: "Football", positions: FOOTBALL_POSITIONS },
  { name: "Basketball", positions: BASKETBALL_POSITIONS },
  { name: "Baseball", positions: BASEBALL_POSITIONS },
];

// Generate a single mock athlete
const generateMockAthlete = (id) => {
  const firstName = randomElement(FIRST_NAMES);
  const lastName = randomElement(LAST_NAMES);
  const state = randomElement(STATES);
  const city = CITIES[state] ? randomElement(CITIES[state]) : "Unknown";
  const highSchool = randomElement(HIGH_SCHOOLS);
  const sport = randomElement(SPORTS);
  const position = randomElement(sport.positions);
  const stars = randomNumber(1, 5);
  const height = randomNumber(65, 82); // 5'5" to 6'10"
  const weight = randomNumber(150, 320);
  const gpa = randomNumber(2.0, 4.0, 1);
  const act = randomNumber(18, 36);
  const sat = randomNumber(900, 1600, -2); // Round to nearest 10
  const fortyTime = randomNumber(4.3, 5.8, 2);
  const benchPress = randomNumber(135, 400, -5); // Round to nearest 5
  const squat = randomNumber(200, 600, -5); // Round to nearest 5
  const verticalJump = randomNumber(20, 45, 1);
  const graduationYear = randomNumber(2025, 2028);

  const hasBeenViewed = randomBoolean(0.3);
  const isBookmarked = randomBoolean(0.2);
  const similarToCurrentPlayer = randomBoolean(0.15)
    ? randomElement(FIRST_NAMES) + " " + randomElement(LAST_NAMES)
    : null;
  const lastActivity = randomDate(new Date(2025, 0, 1), new Date());

  return {
    id,
    firstName,
    lastName,
    state,
    city,
    highSchool,
    sport: sport.name,
    position,
    stars,
    height,
    weight,
    gpa,
    act,
    sat,
    fortyTime,
    benchPress,
    squat,
    verticalJump,
    graduationYear,

    hasBeenViewed,
    isBookmarked,
    similarToCurrentPlayer,
    lastActivity,
    // Format height as feet and inches
    get heightFormatted() {
      const feet = Math.floor(this.height / 12);
      const inches = this.height % 12;
      return `${feet}'${inches}"`;
    },
  };
};

// Generate multiple mock athletes
export const generateMockAthletes = (count) => {
  return Array.from({ length: count }, (_, i) => generateMockAthlete(i + 1));
};

// Export default
export default {
  generateMockAthletes,
};
